import { render, staticRenderFns } from "./PopupDataEditNotification.vue?vue&type=template&id=232e718e&scoped=true"
import script from "./PopupDataEditNotification.vue?vue&type=script&lang=js"
export * from "./PopupDataEditNotification.vue?vue&type=script&lang=js"
import style0 from "./PopupDataEditNotification.vue?vue&type=style&index=0&id=232e718e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e718e",
  null
  
)

export default component.exports